import { useTheme } from "@emotion/react";
import { Typography } from "@mui/material";
import React from "react";
import COLORS from "../colors/colors";

const GJChip = ({ title }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  return (
    <Typography
      variant="span"
      fontWeight={600}
      sx={{
        padding: "4px 8px",
        borderRadius: 4,
        backgroundColor: isDarkMode ? COLORS.DISABLED_BG_DARK : COLORS.DISABLED_BG_LIGHT,
        textTransform: "capitalize",
      }}
    >
      {title}
    </Typography>
  );
};

export default GJChip;
